import { min, max, minmax } from './min-max.rule'
import { pattern, email, phone, url, idNo, plateNo, noChinese, chinese } from './pattern.rule'
import { required } from './require.rule'

export const Validators = {
    required,
    minmax,
    min,
    max,
    pattern,
    email,
    phone,
    url,
    idNo,
    plateNo,
    noChinese,
    chinese,
}
